
import { PivotSignificance } from "../config/smpa";
import { tvpoint } from "../tv";
export enum MarkToolCat {
	None,
	Bias,
	Poi,
	Fvg,
	Swp,
	Raid,
	Level,
	Sessions,
	DO,
	WO,
	MO,
	NO,
	PremDisc,
	Eq,
	Swing,
	Cascade,
	TgSwng,
	TgBuildUp,
	TgFvg,
}

export interface Marker {
	c: MarkToolCat;
	n: string;
	id: number;
}

export interface SmpaToolBase {
	uid: number;
}
export interface SmpaInZone extends SmpaToolBase {
	t: MarkToolCat;
	tf: string;
}

export interface SmpaToolMark extends SmpaToolBase {
	m: Marker;
}
export interface SmpaToolInfo extends SmpaToolMark {
	i: SmpaInZone[];//inside
	p: string[];
	fg: number;//flags
	ib: boolean;//is bull
	ts: number;
	bf: number[];//base for
	ff: number[];//favor for
	af: number[];//await for
}
export interface SmpaZoneInfo extends SmpaToolInfo {
	f: tvpoint;//from
	t: tvpoint;//to
	inf: number[];//inside for
}
export interface SmpaSweepInfo extends SmpaZoneInfo {
	c: string;
	qm: string;
	tdp: tvpoint;//3d sweep pv
	tp: tvpoint;//peak pivot
	el: LevelLiqType;//exact levels
	ol: LevelLiqType;//co levels
}
export interface SmpaFvgInfo extends SmpaZoneInfo {
	fl: number;//fill
	tp: tvpoint;
}
export enum LevelLiqType {
	Any = -1,
	None = 0,
	PD = 1,
	PM = 2,
	PW = 4,
	A = 8,
	F = 16,
	L = 32,
	N = 64,
}

export interface SmpaLevelInfo extends SmpaZoneInfo {
	n: LevelLiqType;
	fn: string;
}

export interface SmpaPDZoneInfo {
	h: number;
	l: number;
	f: number;
	t: number;
	ib: boolean;
}
export enum SmpaPoiType {
	SB,
	MB,
	BB,
	OB,
	ISB,
	//BRP,
	//STB,
	//BTS,
	//DZ,
	//SZ
}
export enum PoiToolType {
	LastBos,
	MostRecent,
	Old
}
export interface SmpaStructPoiInfo extends SmpaZoneInfo {
	bd?: tvpoint;//mitigation braker block depth
	ot: SmpaPoiType;
	eb: number;
	peb: number;
	psb: number;
	ptb: number;
	
	bo: SmpaInZone[];
	//re: SmpaStructPoiInfo[];
	rf: number;//refine for
	ls: LevelLiqType;
	s: PivotSignificance;
	m_in: StructBosLine;
	mm_in: StructBosLine;
	m_mi: StructBosLine;
	m_co: StructBosLine;
	type: PoiToolType;
	
}
export interface SmpaTargetInfo extends SmpaToolMark {
	ib: boolean;
	fm: number;
}
export interface SmpaBuildUpTargetInfo extends SmpaTargetInfo {
	tm?: number;
	pv?: tvpoint;
}

export interface BuildUpPoint extends tvpoint {
	k: number;
	is: boolean;
	s: PivotSignificance;
}
export interface SmpaBuildUpInfo extends SmpaToolInfo {
	ps: BuildUpPoint[];
	i0: tvpoint;
	i1: tvpoint;
	re: BuildUpPoint[][];
}
export enum MarkOpenType {
	DO = MarkToolCat.DO,
	WO,
	MO,
	NO
}
export interface SmpaOpenInfo extends SmpaToolMark {
	n: MarkOpenType;
	f: tvpoint;
	t: tvpoint;
}

export interface SmpaBiasInfo extends SmpaToolBase {
	//ip: boolean;
	d: string;
}
//export enum MarkSessionType {
//	Asia,
//	Frankfurt,
//	London,
//	NewYork
//}
export interface SmpaSessionInfo extends SmpaToolMark {
	n: LevelLiqType;
	f: tvpoint;
	t: tvpoint;
}
export interface SmpaTargetRef {
	i: number;
	c: MarkToolCat;
}
export enum BosInfo {
	bos,
	CoS,
	ch,
	sms,
}
export interface StructBosLine {
	f: tvpoint;
	t: tvpoint;
}
export enum StructBosFacilityType {
	IA,
	IL,
	FA,
	BA,
	BL,
	BMFC,
	IM,
	IR,
	AI = 255
}
export interface StructBosFacility {
	a: number;
	c: number;
	t: StructBosFacilityType;
}
export interface StructBos extends StructBosLine {
	i: BosInfo;
	fa: StructBosFacility;
}
export interface StructMove extends tvpoint {
	i: number;
	f: number;
	st: tvpoint;
	//bd: tvpoint;
	b: StructBos;
	fb: StructBosLine;
	ch: StructMove[];
}
export interface StructLevel extends tvpoint {
	f: number;
}
export interface SmpaToolInfoTools<TTool extends SmpaToolInfo> {
	be: TTool[];
	bu: TTool[];
}
export interface SmpaTFInfo {
	tf_disp: string;
	tf_tv: string;
	info: string;
	lb: number;

	bullInfo: SmpaBiasInfo;
	bearInfo: SmpaBiasInfo;
	pd: SmpaPDZoneInfo;
	pois: SmpaToolInfoTools<SmpaStructPoiInfo>;
	fvgs: SmpaToolInfoTools<SmpaFvgInfo>;
	sweeps: SmpaToolInfoTools<SmpaSweepInfo>;
	buildUps: SmpaToolInfoTools<SmpaBuildUpInfo>;
	opens: SmpaOpenInfo[];
	sessions: SmpaSessionInfo[];
	levels: SmpaToolInfoTools<SmpaLevelInfo>;

	simple: StructMove[];
	fractal: StructMove[];
	swing: StructMove[];
	swinglvls: StructLevel[];

	tgs: SmpaTargetRef[];
	fvgTgs: SmpaTargetInfo[];
	buildUpTgs: SmpaBuildUpTargetInfo[];
	swngTgs: SmpaBuildUpTargetInfo[];
}
